<template>
  <Modal class="dea-modal-add-subjects dea-modal--no-footer" :visible="visible" @modalClose="$emit('close-modal')">
    <template slot="title">
      Quali materie insegni?
    </template>
    <template slot="content">
      <div class="dea-modal-add-subjects__grades">
        <div class="dea-modal-add-subjects__grades-title dea-heading--regular-l">
          Scegli il grado scolastico
        </div>
        <div class="dea-modal-add-subjects__grades-subtitle dea-heading--regular-xs">
          Se insegni in scuole di diversi gradi scolastici, indica il grado per cui vorresti ricevere informazioni.
        </div>
        <div class="dea-modal-add-subjects__grades-buttons">
          <Buttons
            v-for="el in $root.asyncConf.degrees_json"
            :key="`grade-${el.id}`"
            class="dea-button--large"
            :class="{ 'dea-button--outline': !grade || el.id !== grade.id }"
            @click="selectGrade(el)"
          >
            {{ el.name }}
          </Buttons>
        </div>
      </div>
      <div v-if="grade" class="dea-modal-add-subjects__groups">
        <div class="dea-heading--regular-l">
          Scegli un'area disciplinare
        </div>
        <div class="dea-modal-add-subjects__groups-select">
          <InputSelect name="groupsList" placeholder="Scegli un'area disciplinare" @change="selectGroup($event)">
            <option v-for="(option, idx) in groupsList" :key="idx" :selected="group === option" :value="option">{{
              option
            }}</option>
          </InputSelect>
        </div>
      </div>
      <div v-if="group" class="dea-modal-add-subjects__checkboxes">
        <div class="dea-modal-add-subjects__checkboxes-title dea-heading--regular-l">
          Scegli una o più materie
        </div>
        <div class="dea-modal-add-subjects__checkboxes-list">
          <Checkbox
            v-for="(option, idx) in subjectsList"
            :id="`${option.id}`"
            :key="`${group}-${idx}`"
            :name="`${option.id}`"
            :checked="subjectsCheck[option.id]"
            type="checkbox"
            @change="switchCheckbox(option.id)"
          >
            {{ option.name }}
          </Checkbox>
        </div>
      </div>
      <div class="dea-modal-add-subjects__button dea-modal-buttons">
        <Buttons class="dea-button--large" :disabled="isDisabled" @click="saveSettings">
          Salva modifiche
        </Buttons>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapMutations } from "vuex";
import Buttons from "@/components/elements/Buttons";
import Checkbox from "@/components/elements/Checkbox";
import InputSelect from "@/components/elements/InputSelect";
import Modal from "@/components/patterns/Modal";
import Schools from "../../../clients/schools";

export default {
  name: "AddSubjectsModal",
  components: { Buttons, InputSelect, Checkbox, Modal },
  props: {
    clusterTeacher: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clusters: [],
      grade: null,
      group: null,
      clustersList: {
        "1": {},
        "2": {},
        "3": {},
      },
      subjectsCheck: {},
      initialSubjectsCheck: {},
    };
  },
  computed: {
    isDisabled() {
      return !this.group || Object.keys(this.subjectsCheck).length === 0;
    },
    groupsList() {
      if (this.grade) {
        return Object.keys(this.clustersList[this.grade.id]);
      }
      return [];
    },
    subjectsList() {
      if (this.grade && this.group) {
        return this.clustersList[this.grade.id][this.group];
      }
      return [];
    },
  },
  mounted() {
    this.clusters = JSON.parse(sessionStorage.getItem("clusters"));
    this.clusters.forEach(el => {
      if (this.clustersList[`${el.degree_id}`][el.group]) {
        this.clustersList[`${el.degree_id}`][el.group].push(el);
      } else {
        this.clustersList[`${el.degree_id}`][el.group] = [el];
      }
    });

    if (this.clusterTeacher.length) {
      this.grade = this.$root.asyncConf.degrees_json[this.clusterTeacher[0].degree_id - 1];
      this.group = this.clusterTeacher[0].group;
      this.clusterTeacher.forEach(el => {
        this.subjectsCheck[el.id] = true;
        this.initialSubjectsCheck[el.id] = true;
      });
    }
  },
  methods: {
    ...mapMutations(["setUser"]),
    async saveSettings() {
      const toDelete = this.whichDelete();
      const toSave = this.whichSave();
      document.querySelector("body").classList.add("wait");
      if (toDelete.length) {
        const delPromise = toDelete.map(async el => {
          const singleDelete = await Schools.deleteClusterTeacher(this.$root.config, el, this.user.id);
          return singleDelete;
        });
        await Promise.all(delPromise);
      }

      if (toSave.length) {
        const savePromise = toSave.map(async el => {
          const body = {
            cluster_id: el,
            user_id: this.user.id,
            type: "ADOPTION",
          };
          const singleSave = Schools.saveClusterTeacher(this.$root.config, body);
          return singleSave;
        });
        await Promise.all(savePromise);
      }

      const updatedUser = await Schools.getUpdateAgencies(this.$root.config);
      this.setUser(updatedUser);
      this.$emit("close-modal");
      document.querySelector("body").classList.remove("wait");
    },
    selectGrade(grade) {
      this.group = null;
      this.grade = grade;
    },
    selectGroup(evt) {
      this.subjectsCheck = {};
      this.group = evt.target.value;
    },
    switchCheckbox(id) {
      if (this.subjectsCheck[id]) {
        this.$set(this.subjectsCheck, id, !this.subjectsCheck[id]);
      } else {
        this.$set(this.subjectsCheck, id, true);
      }
    },
    whichDelete() {
      const initial = Object.keys(this.initialSubjectsCheck);
      const after = Object.keys(this.subjectsCheck).filter(el => {
        return this.subjectsCheck[el];
      });
      const delId = initial.filter(id => {
        return after.indexOf(id) === -1;
      });
      return delId;
    },
    whichSave() {
      const initial = Object.keys(this.initialSubjectsCheck);
      const after = Object.keys(this.subjectsCheck).filter(el => {
        return this.subjectsCheck[el];
      });
      const saveId = after.filter(id => {
        return initial.indexOf(id) === -1;
      });
      return saveId;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-modal-add-subjects {
  &__grades {
    &-subtitle {
      margin-top: $space-x-small;
    }

    &-buttons {
      @include media("<=l") {
        flex-direction: column;
      }

      display: flex;
      flex-direction: row;
      margin: $space-base 0;

      button {
        @include media("<=l") {
          margin: $space-x-small 0;
        }

        margin-right: $space-base;
      }
    }
  }

  &__groups-select {
    margin-bottom: $space-base;

    .dea-input--input-select {
      @include media("<=l") {
        max-width: 100%;
      }
    }
  }

  &__checkboxes-list {
    margin: $space-base 0;
  }
}
</style>
